import {
  ControlCenterSettingsApi,
  useControlCenterSettingsAPI,
} from "melco-shared-logic";
import { useCallback } from "react";
import { useCurrentProductVariant } from "../useCurrentProductVariant";

type AppSettingsResult = {
  success?: boolean;
  appSettingsResponse: any;
  error?: any;
};

const initialValue = { success: undefined, appSettingsResponse: undefined };

export const useAppSettings = () => {
  const productVariant = useCurrentProductVariant();
  console.log(productVariant);
  const handleRequest = useCallback(async (api: ControlCenterSettingsApi) => {
    try {
      const response = await api.settingsGetControlCenterAppSetting();
      //  console.log(response)

      return {
        success: true,
        appSettingsResponse: response,
        error: undefined,
      };
    } catch (error) {
      console.log(error);
      return {
        success: false,
        appSettingsResponse: undefined,
        error: error,
      };
    }
  }, []);

  return useControlCenterSettingsAPI<AppSettingsResult>({
    initialValue,
    handleRequest,
  });
  // return useAPIQuery(
  //   ControlCenterSettingsApi,
  //   ["appsettings"],
  //   async (api) => {

  //     debugger;
  //     const response = await api.productSettingsGetControlCenterAppSetting();
  //     debugger;
  //     console.log(response)
  //     debugger;
  //     return response;
  //   },
  // )
};
